import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
// modules
import Fetch from 'modules/Fetch';
import { LStorage } from 'modules/Storage';
import FormatService from 'modules/Format';
import Logger from 'modules/Logger';
// typings
import { SegmentType } from 'modules/Search/constants';
import {
  TvChartSpecialTradingDates,
  SpecialTradingDatesResponse,
} from './typings';

dayjs.extend(utc);
dayjs.extend(customParseFormat);

class SpecialTradingDates {
  private specialTradingDates = {} as TvChartSpecialTradingDates;

  // init data fetching
  init = async () => {
    // Remove special trading dates from local storage
    LStorage.removeItem('SPECIAL_TRADING_DATES');
    await this.getSpecialTradingDates();
  };

  getSpecialHolidayRules =
    (segment: SegmentType) => this.specialTradingDates[segment] || '';

  async getSpecialTradingDates(): Promise<void> {
    try {
      const response: HttpResponse<SpecialTradingDatesResponse> =
        await Fetch.request(
          'SPECIAL_TRADING_DATES',
          '',
          'SPECIAL_TRADING_DATES',
        );

      if (response.success && response.data) {
        const specialTradingDates = FormatService.formatSpecialTradingDates(
          response?.data?.specialTradingDates,
        );

        this.specialTradingDates = specialTradingDates;
      }
    } catch (error) {
      Logger.error(error);
    }
  }
}

export default new SpecialTradingDates();
